import { Metamodel } from 'app/model/base/model';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { OracleLinkedService } from './oracle.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.amazonRdsForOracle.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AmazonRdsForOracle_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AmazonRdsForOracle_DisplayText)
    ]
})
export class AmazonRdsForOracleLinkedService extends OracleLinkedService {
}
